import {editorValueSignature,type NativeEditorEnvelope} from '../../protocol/native-envelope';
import {readNativeDocumentFile,type NativeFileState} from './native-document-file';

export const MAX_WORK_BACKUP_BYTES=16_000_000;

/** A backup opens only in the work and original production context it actually belongs to. */
export function prepareWorkBackupRestore(raw:unknown,current:NativeEditorEnvelope):NativeFileState {
  const read=readNativeDocumentFile(raw);
  if(read.status!=='ready')throw new Error(read.status==='error'?read.message:'정밀 편집 백업 파일을 확인해 주세요.');
  const next=read.value.envelope,a=current.scope,b=next.scope;
  if(!a||!b||a.projectId!==b.projectId||a.workId!==b.workId||a.surface!==b.surface)
    throw new Error('다른 작업의 백업입니다. 이 파일을 만든 작업에서 열어 주세요. 현재 편집은 바꾸지 않았습니다.');
  if(next.sourceSnapshotHash!==current.sourceSnapshotHash
    ||editorValueSignature(next.sourceContext)!==editorValueSignature(current.sourceContext))
    throw new Error('원래 제작 자료가 다른 파일입니다. 이 작업의 전체 백업을 선택해 주세요. 현재 편집은 바꾸지 않았습니다.');
  return {...read.value,requiresInitialSave:true,
    importNotice:'백업 편집본을 열었습니다. 서버에는 아직 저장하지 않았습니다. 저장하거나 복원 전 편집으로 돌아갈 수 있습니다.'};
}

export function parseWorkBackupText(text:string,current:NativeEditorEnvelope):NativeFileState {
  if(new TextEncoder().encode(text).byteLength>MAX_WORK_BACKUP_BYTES)throw new Error('백업 파일이 너무 큽니다. 16MB 이하 파일을 선택해 주세요.');
  let raw:unknown;try{raw=JSON.parse(text);}catch{throw new Error('편집 백업 파일의 내용을 읽지 못했습니다. 전체 파일을 선택하거나 내용을 다시 붙여넣어 주세요.');}
  return prepareWorkBackupRestore(raw,current);
}
